module.exports = __webpack_public_path__ + "img/20210103.8cf63917.png";